'use client'
import * as stylex from '@stylexjs/stylex'
import Script from 'next/script'
import { fontFamilies } from '../../styles/tokens.stylex'
import { sendGTMEvent } from '@next/third-parties/google'

interface InlineFormProps {
  formId?: string
  styles?: stylex.StyleXStyles
}

export function InlineForm({ formId, styles, ...props }: InlineFormProps) {
  return (
    <>
      <div
        data-hubspot-embed-form-id={`${formId}`}
        {...stylex.props(sx.form, styles)}
        {...props}
      ></div>
      <Script
        src="//js.hsforms.net/forms/embed/v2.js"
        id="hubspot-form-script"
        strategy="lazyOnload"
        onReady={() => {
          //@ts-expect-error hbspt
          hbspt.forms.create({
            region: 'na1',
            portalId: '8035366',
            formId,
            target: `[data-hubspot-embed-form-id="${formId}"]`,
            onFormSubmitted: () => {
              sendGTMEvent({
                event: 'hubspot_form_submitted',
                value: formId,
                location: 'contactUsBlock',
              })
            },
          })
        }}
      />
    </>
  )
}

const sx = stylex.create({
  form: { fontFamily: `${fontFamilies.paragraph} !important` },
})
